module.exports = __webpack_public_path__ + "img/photo-car-service-transportation-concept-tow-truck-transpo-1.1a777e56.png";